import React from 'react';

import AdjustForm from './adjust/AdjustForm';
import Connections from './connections/Connections';
import GeneratedContentUpdateController from './components/generated-content-update-controller/GeneratedContentUpdateController';
import SessionHistoryPanel from './session-history-panel/SessionHistoryPanel';
import SessionLoadingController from './components/session-loading-controller/SessionLoadingController';
import { ProjectProvider } from '../../context/ProjectContext';
import { PROJECT_VARIANTS } from '../../constants';

import scss from './Story.module.scss';

function Story() {
  return (
    <ProjectProvider projectType='STORY' projectVariant={PROJECT_VARIANTS.ADMIN}>
      <div className={scss.wrapper}>
        <AdjustForm />

        <Connections />

        <GeneratedContentUpdateController />
        <SessionLoadingController />

        <SessionHistoryPanel />
      </div>
    </ProjectProvider>
  );
}

export default Story;
